export const DETAILS_PAGE_URL_DISCRIMINATOR_PARAM = 'd';

export const DOC_UPLOAD_WITH_FILE_METADATA_EXTRACTION_KEY =
  'readFromFileMetadata';

export const COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
